import { useEffect, useState } from 'react';
import L from 'leaflet';
import { getMode } from '../lib/profiles';
import { areaCoverage, needsWater } from '../lib/coverage';

const KEY = 'giss_dry';
export const dryOn = () => localStorage.getItem(KEY) === '1';
export const setDryOn = (v) => { localStorage.setItem(KEY, v ? '1' : '0'); window.dispatchEvent(new Event('giss-dry')); };
export function useDryOn() {
  const [on, setOn] = useState(dryOn);
  useEffect(() => { const h = () => setOn(dryOn()); window.addEventListener('giss-dry', h); return () => window.removeEventListener('giss-dry', h); }, []);
  return on;
}

// garden: red = no sprinkler reaches, yellow = only one sprinkler; label with percentages per area
export default function useDryLayer(mapRef, gardens, fittings, t, strict) {
  const on = useDryOn();
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !on || getMode() !== 'garden') return undefined;
    const rend = L.canvas({ padding: 0.3 }), g = L.layerGroup();
    (gardens || []).filter((x) => x.pts?.length > 2 && needsWater(x)).forEach((x) => {
      const c = areaCoverage(x, fittings, strict);
      c.cells.forEach((k) => g.addLayer(L.rectangle(k.b, { renderer: rend, stroke: false, fillColor: k.n ? '#facc15' : '#dc2626', fillOpacity: k.n ? 0.35 : 0.45, interactive: false })));
      // result tag outside the area: left of its westernmost corner, never on top of the drawing
      const west = x.pts.reduce((a, p) => (p[1] < a[1] ? p : a), x.pts[0]);
      g.addLayer(L.marker(west, { interactive: false, keyboard: false, icon: L.divIcon({ className: 'dry-tag-wrap', iconSize: null, html: `<div class="dry-tag out" data-testid="dry-tag-${x.id}"><b>${x.name.replace(/[<>&]/g, '')}</b><span class="d">${c.dry} % ${t.dryDry}</span><span class="w">${c.weak} % ${t.dryWeak}</span><span class="o">${c.ok} % ${t.dryOk}</span></div>` }) }));
    });
    g.addTo(map);
    return () => g.remove();
  }, [mapRef, gardens, fittings, on, t, strict]);
}
